import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined"
import MonetizationOnOutlined from "@mui/icons-material/MonetizationOnOutlined"
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined"
import Chip from "@mui/material/Chip"
import Paper from "@mui/material/Paper"
import Skeleton from "@mui/material/Skeleton"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2"
import { styled } from "@mui/material/styles"
import { useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { formatCurrency } from "../../../common/utils"

export default function SummaryTab({ isLoading, setIsLoading }) {
  const [stages, setStages] = useState([])
  const axios = useAuthorizedAxiosClient()

  useEffect(
    () => {
      setIsLoading(true)
      axios
        .get("/crm/api/crm-stages/summary/")
        .then(({ data }) => setStages(data))
        .finally(() => setIsLoading(false))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <Grid container spacing={2}>
      {isLoading
        ? new Array(12).fill(null).map((_, i) => (
            <GridItem key={i}>
              <Skeleton
                variant="rounded"
                width={"100%"}
                height={130}
                animation="wave"
                sx={{
                  transition: "opacity 0.4s",
                  opacity: 1,
                  transitionDelay: `${i * 100}ms`,
                }}
              />
            </GridItem>
          ))
        : stages.map((stage) => (
            <GridItem key={stage.id}>
              <StagePaper>
                <PaperContentColumn>
                  <Typography variant="h5">{stage.name}</Typography>
                  <StatLine
                    Icon={PersonOutlinedIcon}
                    stat={stage.candidate_count}
                    percentage={stage.candidate_percentage}
                  />
                  <StatLine
                    Icon={MonetizationOnOutlined}
                    stat={formatCurrency(stage.total_annual_value)}
                    percentage={stage.total_annual_value_percentage}
                  />
                </PaperContentColumn>
                <HighlightedPaperContentColumn>
                  <Row sx={{ alignItems: "center", gap: 1 }}>
                    <CalendarTodayOutlinedIcon />
                    <Typography
                      variant="body1"
                      sx={{ color: "text.secondary" }}
                    >
                      Avg time:
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {stage.avg_age_in_stage
                        ? `${Math.round(
                            stage.avg_age_in_stage / (60 * 60 * 24)
                          )} days`
                        : "-"}
                    </Typography>
                  </Row>
                </HighlightedPaperContentColumn>
              </StagePaper>
            </GridItem>
          ))}
    </Grid>
  )
}

function StatLine({ Icon, stat, percentage }) {
  return (
    <Row sx={{ justifyContent: "space-between", alignItems: "center" }}>
      <Row sx={{ alignItems: "center", gap: 1 }}>
        <Icon />
        <Typography variant="h6">{stat}</Typography>
      </Row>
      <Chip
        variant="filled"
        color="default"
        size="small"
        label={`${Math.floor(percentage * 100)}%`}
      />
    </Row>
  )
}

const GridItem = styled((props) => <Grid md={3} sm={6} xs={12} {...props} />)(
  () => ({})
)

const StagePaper = styled((props) => <Paper elevation={2} {...props} />)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  })
)

const PaperContentColumn = styled(Column)(({ theme }) => ({
  gap: theme.spacing(1),
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1),
}))

const HighlightedPaperContentColumn = styled(PaperContentColumn)(
  ({ theme }) => ({
    borderTop: `1px solid ${theme.palette.colors.gray200}`,
  })
)
